const webContact = {
  webTicketList: '/api/v1/admin/landingpage-tickets',
  markWebTicketRead: '/api/v1/admin/landingpage-ticket-read',
}

export const webContactApiRoutes = {
  ...webContact,
}
